import { useMemo } from "react";

import { useMedplumProfile } from "@medplum/react";

import { ProfileContext } from "../../contexts/profile";

interface ProfileProviderProps {
  children: React.ReactNode;
}

export default function ProfileProvider({ children }: ProfileProviderProps) {
  const profile = useMedplumProfile();

  const value = useMemo(() => {
    const fullName = `${profile?.name?.[0]?.given} ${profile?.name?.[0]?.family}`?.trim();
    const isPatient = profile?.resourceType === "Patient";
    return { profile, isPatient, fullName };
  }, [profile]);

  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
}
